/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * MPD song queue item.
 */
export type SongItem = {
    /**
     * MPD queue ID
     */
    id: string;
    /**
     * File path in MPD
     */
    file: string;
    /**
     * Song title
     */
    title?: (string | null);
    /**
     * Song artist
     */
    artist?: (string | null);
    /**
     * Song album
     */
    album?: (string | null);
    /**
     * Song genre
     */
    genre?: (string | null);
    /**
     * Song duration
     */
    time?: (string | null);
    /**
     * Position in queue
     */
    pos?: (string | null);
    /**
     * Playlist source: user, fallback, or live
     */
    playlist: SongItem.playlist;
    /**
     * User-facing reference URL for clickable links
     */
    reference_url?: (string | null);
    /**
     * Direct stream URL for this cached song
     */
    direct_url?: (string | null);
};
export namespace SongItem {
    /**
     * Playlist source: user, fallback, or live
     */
    export enum playlist {
        USER = 'user',
        FALLBACK = 'fallback',
    }
}

